'use strict';
var analysisGraphStackingTpl = require('./stacking/graph-stacking.html');
var util = require('../../util/property-util');
var nocUtil = require('../../util/noc-util');
var arrayUtil = require('../../util/array-util');

module.exports = /*@ngInject*/ ["$rootScope", "$scope", "HighChartFactory", "MessageDataStructure", "trainData", "MessageDataRepository", "MessageDataFilter", "ChartAnalysisFactory", "$timeout", "$q", "MessageDataStructureStorage", "UrlRoutingFactory", "CsvFactory", "$filter", "$uibModal", "GraphStackingStorage", "boxDiscriminationInfo", "coachDiscriminationInfo", "obisDiscriminationInfo", "TimeZoneFactory", "ConfigurationStoreService", "ProjectService",
 function ($rootScope, $scope, HighChartFactory, MessageDataStructure, trainData, MessageDataRepository, MessageDataFilter, ChartAnalysisFactory, $timeout, $q, MessageDataStructureStorage, UrlRoutingFactory, CsvFactory, $filter, $uibModal, GraphStackingStorage, boxDiscriminationInfo, coachDiscriminationInfo, obisDiscriminationInfo, TimeZoneFactory, ConfigurationStoreService, ProjectService) {

    var ch = this;
    ch.parent = $scope.$parent.base;
    var name = 'chart';
    var livePoller = undefined;
    var poller = {};
    var maxX = 0;
    var projectConfiguration = ConfigurationStoreService.getProjectConfiguration( ProjectService.getSelectedProjectId());

    ch.step = projectConfiguration && projectConfiguration.chartConfiguration && projectConfiguration.chartConfiguration.lineChartStep;
    ch.pointMarkersOnly = projectConfiguration && projectConfiguration.chartConfiguration && projectConfiguration.chartConfiguration.pointMarkersOnly;
    ch.pointMarkerRadius = projectConfiguration && projectConfiguration.chartConfiguration && projectConfiguration.chartConfiguration.pointMarkerRadius;

    var init = function () {
        "use strict";
        var own = ch.parent.getChildByName(name);
        own.loaded.deferred.resolve();

        ch.chart = HighChartFactory.createChart('chart-container');
        ch.chart.tooltipHidden = false;
        ch.messageStructure = new MessageDataStructure(boxDiscriminationInfo, coachDiscriminationInfo, obisDiscriminationInfo);
        ch.viewStructure = new MessageDataStructure(boxDiscriminationInfo, coachDiscriminationInfo, obisDiscriminationInfo);

        ch.trainData = trainData;
        ch.showPanel = false;
        ch.dataGrouping = true;
        ch.template = {};
        ch.templates = [];
        ch.options = {
            isLive: false,
            isFollow: false,
            intervalTime: 15,
            ignoreGaps: true
        };
        ch.isLoading = false;
        ch.filledGaps = false;
        ch.stack = false;

        loadOptionsFromUrl();

        var storedMessageDataStructure = MessageDataStructureStorage.get(name);
        if (util.isDefined(storedMessageDataStructure)) {

            ch.messageStructure = storedMessageDataStructure;
            ch.viewStructure = storedMessageDataStructure;
            if (util.isDefined(ch.messageStructure.getCurrentState().messageName)) {
                ch.showPanel = true;
            }

            if (ch.stack) {
                var stackAfterDrawing = $scope.$on('graph-drawn', function () {
                    var data = GraphStackingStorage.get(name);
                    if (util.isDefined(data)) {
                        ch.applyStackingList(data);
                    } else {
                        ch.chart.series.forEach(function (serie) {
                            var size = serie.size;
                            serie.update({type: 'area', stacking: 'normal'}, false);
                            serie.size = size;
                        });
                        ch.chart.redraw();
                    }

                    stackAfterDrawing();
                });
            }

            addMessage();
        } else {
            ch.stack = false;
        }

    };

    $scope.$on('activate-' + name, function () {
        "use strict";
        if (util.isDefined(ch.chart)) {
            ch.chart.reflow();
        }
    });

    $scope.$on('de-activate-' + name, function () {
        "use strict";
    });

    /**
     * Sets the panel to the iniatial state of the given messageName.
     * @param messageName   -   MessageName used in the dataFields.
     */
    ch.setMessageName = function (messageName) {
        "use strict";
        ch.viewStructure.setInitialState(messageName);
        ch.showPanel = true;
    };

    var loadOptionsFromUrl = function () {

        // let's just assume that all are set when reload is set
        if (!util.isDefined(UrlRoutingFactory.get("reload"))) {
            return;
        }

        if (!trainData.isTrip) {
            ch.options.isLive = nocUtil.parseStringToBoolean(UrlRoutingFactory.get("live"));
            ch.options.isFollow = nocUtil.parseStringToBoolean(UrlRoutingFactory.get("follow"));
            ch.options.intervalTime = Number(UrlRoutingFactory.get("intervalTime"));
        }

        ch.stack = nocUtil.parseStringToBoolean(UrlRoutingFactory.get("stacking"));
        if (util.isDefined(UrlRoutingFactory.get("ignoreGaps"))) {
            ch.options.ignoreGaps = nocUtil.parseStringToBoolean(UrlRoutingFactory.get("ignoreGaps"));
        } else {
            ch.options.ignoreGaps = true;
        }
    };

    var saveOptionsToUrl = function (options) {
        if (!trainData.isTrip) {
            UrlRoutingFactory.save("live", options.isLive);
            UrlRoutingFactory.save("follow", options.isFollow);
            UrlRoutingFactory.save("intervalTime", options.intervalTime);
            UrlRoutingFactory.save("ignoreGaps", options.ignoreGaps);
        }
    };

    ch.isEmpty = function () {
        if (ch.chart.series.length === 0) {
            return true;
        } else {
            var found = false;
            ch.chart.series.some(function (serie) {
                found = serie.options.data.length > 0;
                return found;
            });
            return !found;
        }
    };

    /**
     * Removes all the series from the chart and redraws the chart. This results in an empty chart.
     */
    ch.clearChart = function () {
        "use strict";
        ch.stack = false;
        UrlRoutingFactory.save("stacking", ch.stack);

        ch.chart.series = ch.chart.series
            .filter(serie => serie.options.name === "Navigator")
        UrlRoutingFactory.delete('templateConfigName');
        ch.chart.redraw();
        ch.resetMessageStructure(ch.viewStructure);

        ch.chart = HighChartFactory.createChart('chart-container');
        MessageDataStructureStorage.save(name, undefined);
    };

    $rootScope.$on("timeZoneChanged", function () {
        if (util.isDefined(ch.chart)) {
            ch.clearChart();
        }
    });

    ch.resetMessageStructure = function (messageStructure) {
        messageStructure.filterDiscriminators(boxDiscriminationInfo, messageStructure.mar3MessageNames);

        if (util.isDefined(coachDiscriminationInfo)) {
            messageStructure.filterDiscriminators(coachDiscriminationInfo, messageStructure.coachMessageNames);
        }

        messageStructure.setMessageName(undefined);
        messageStructure.getMessageNamesWithSelectedProperties().forEach(function (messageName) {
            messageStructure.resetProperties(messageName);
        });
    };

    /**
     * Zooms the chart to the initial zoom level ( maximum )
     */
    ch.zoomOut = function () {
        ch.chart.xAxis[0].setExtremes(ch.trainData.from, ch.trainData.to);
        ch.chart.reflow();
        ch.chart.redraw();
        //updateChartLine();
    };

    /**
     * Downloads the chart as a CSV file.
     */
    ch.downloadCSV = function () {
        var csvString = HighChartFactory.createHighStockCSVString(ch.chart);
        var downloadName = "";

        if (trainData.isTrip) {
            downloadName = "P" + trainData.projectId + "_T" + trainData.relativeTrainId + "_" + trainData.trajectory;
        } else {
            downloadName = "P" + trainData.projectId + "_T" + trainData.relativeTrainId;
        }

        downloadName += "_" + $filter('tzdate')(trainData.from, 'YYYY-MM-DD HH:mm:ss') + "_" + $filter('tzdate')(trainData.to, 'YYYY-MM-dd HH:mm:ss') + ".csv";

        CsvFactory.download(csvString, downloadName);
    };
    /**
     * Downloads the chart as a PNG file.
     */
    ch.downloadPNG = function () {
        ch.chart.exportChart();
    };

    /**
     * Enables/Disables data grouping, data grouping averages the values of nearby points to reduce the number of total points.
     * With data grouping enabled, the performance is increased.
     */
    ch.useDataGrouping = function () {
        ch.dataGrouping = !ch.dataGrouping;
        ch.isLoading = true;
        if (!ch.dataGrouping) {
            ch.chart.series.forEach(function (serie) {
                var size = serie.size;
                serie.update({dataGrouping: {enabled: false}}, false);
                serie.size = size;
            });
        } else {
            ch.chart.series.forEach(function (serie) {
                var size = serie.size;
                serie.update({dataGrouping: {enabled: true}}, false);
                serie.size = size;
            });
        }
        ch.chart.redraw();
        ch.isLoading = false;
    };

    /**
     * Returns if the chart has a series or not.
     * @returns {boolean}
     */
    ch.hasSeries = function () {
        "use strict";
        return ch.chart.series !== undefined ? ch.chart.series.length > 0 : false;
    };

    /**
     * Handler for clicking the apply in the chartAnalysisPanel.
     * The function will fetch data and plot it on the chart.
     * When we only apply the current message, we replace the existing data and want to use the cache.
     * When we use the reload data option, we do not want to use the cache.
     */
    $scope.$on('add-message', function () {
        "use strict";
        addMessage();
    });

    function addMessage() {
        "use strict";
        saveOptionsToUrl(ch.options);

        var messageNames = ch.viewStructure.getMessageNamesWithSelectedProperties();
        updateViewStructureAddStackIndex(messageNames);

        MessageDataStructureStorage.save(name, ch.viewStructure);
        ch.messageStructure.setData(ch.viewStructure.getData());
        ch.messageStructure.setCurrentState(ch.viewStructure.getCurrentState());

        poller.stopPoller();
        var fetchFunction = MessageDataRepository.getMessageData;
        var replace = true;
        var useCache = false;
        ch.isLoading = true;
        ch.putMessagesOnChart(messageNames, fetchFunction, replace, useCache, ch.options.ignoreGaps).then(function () {
            $scope.$emit('graph-drawn');
        });
    }

    /**
     * Update ch.viewStructure to count and add index to each selected property (if needed) for each selected statistic message.
     *
     * @param messageNames
     */
    function updateViewStructureAddStackIndex(messageNames) {
        var maxIndex = ch.viewStructure.getMaxPropertyIndex(messageNames);
        messageNames.forEach(function (selectedMessage) {
            var selectedProperties = ch.viewStructure.getCheckedProperties(selectedMessage);
            ch.viewStructure.updatePropertyOrder(maxIndex, selectedProperties);
        });
    }

    /**
     * Handler for clicking the reset in the chartAnalysisPanel.
     * Resets the properties of the current message.
     * Clears unchecked properties from the chart and redraws it.
     */
    $scope.$on('remove-message', function () {
        "use strict";
        ch.viewStructure.resetProperties(ch.viewStructure.getCurrentState().messageName);
        ch.messageStructure.setData(ch.viewStructure.getData());
        ch.messageStructure.setCurrentState(ch.viewStructure.getCurrentState());
        ch.cleanupChart();
        ch.chart.redraw();

    });

    /**
     * Returns an x value when the the current x value is not close enough to the previous x value
     * @param {Number} current          The current x value (distance)
     * @param {Number} previous         The previous x value (distance)
     * @param {Number} interval         The interval for the data
     * @returns {Number|undefined}      An x value where we need to insert a 'null', if any
     */
    var getInsertNullForXValue = function (current, previous, interval) {
        if (current - previous > interval * 1000) {
            return previous + (1000 * interval);
        }
    };
    /**
     * For each given messageName, we fetch data.
     * We use this data to plot the message on the chart for each selected property.
     * To plot properties on the chart, we have to add all Axes and Series. Once these are created we can add data to the series.
     * When all series are filled, we can redraw the chart.
     * @param messageNames      -   Array of messageNames that contain checked properties
     * @param fetchFunction     -   Function used to fetch data from the backend.
     * @param replace           -   Boolean indicating if we should replace existing data on the chart or append.
     * @param useCache          -   Boolean indicating if we can use the messageRepository cache.
     * @returns {*|promise.promise|Function|jQuery.promise|deferred.promise|{then, catch, finally}}
     */
    ch.putMessagesOnChart = function (messageNames, fetchFunction, replace, useCache, ignoreGaps) {
        "use strict";

        var promiseArray = [];
        var deferred = $q.defer();
        var newMaxX = 0;

        messageNames.forEach(function (messageName) {
            var dataPromise = fetchFunction(messageName, ch.trainData.relativeTrainId, ch.trainData.projectId, ch.trainData.from, ch.trainData.to, ch.messageStructure.getRate(messageName), useCache, ch.messageStructure.isVlinkAggregationEnabled());
            var dataDeferred = $q.defer();
            promiseArray.push(dataDeferred.promise);
            dataPromise.then(function (newData) {
                var data = MessageDataFilter.filterData(newData, messageName, ch.messageStructure);
                if (data.length > 0 && data[data.length - 1].timestamp > newMaxX) {
                    newMaxX = data[data.length - 1].timestamp;
                }
                var selectedProperties = ch.messageStructure.getCheckedProperties(messageName);

                ChartAnalysisFactory.createAxes(ch.chart, selectedProperties);
                ChartAnalysisFactory.createSeries(ch.chart, messageName, selectedProperties, ch.messageStructure, ch.dataGrouping);
                ChartAnalysisFactory.addDataToChart(ch.chart, data, messageName, selectedProperties, ch.messageStructure, createSeriesEntryFromProperty, getInsertNullForXValue, replace, undefined, ignoreGaps);

                updateChartLine();
                dataDeferred.resolve();
            });
        });

        $q.all(promiseArray).then(function () {

            ch.cleanupChart();
            ch.zoomOut();

            ch.isLoading = false;

            if (ch.options.isLive) {
                poller.pollData();
            } else {
                poller.stopPoller();
            }

            deferred.resolve();
        });
        return deferred.promise;
    };

    /**
     * Cleans the chart of unneeded series.
     * The function fetches all the used message names to be able to construct an array of indices of ids that should be present on the chart.
     * If a series exists that is not in this array, it is not needed anymore and can be deleted.
     */
    ch.cleanupChart = function () {
        "use strict";
        var seriesIds = [];
        var messageNames = ch.messageStructure.getMessageNamesWithSelectedProperties();
        messageNames.forEach(function (messageName) {
            var selectedProperties = ch.messageStructure.getCheckedProperties(messageName);
            seriesIds = seriesIds.concat(ChartAnalysisFactory.getSeriesIdsForSelectedProperties(messageName, ch.messageStructure, selectedProperties));
        });
        ChartAnalysisFactory.cleanupSeries(ch.chart, seriesIds);
    };

    /**
     * Function to extract the necessary data from a data object.
     * In this case we need an x,y array with timestamp x and property value y.
     * @param property      -   Object describing which field of the object we require.
     * @param object        -   The data object
     * @returns {Array}
     */
    function createSeriesEntryFromProperty(property, object, timezoneOffset) {
        var chartObject = [];
        //normal axis
        var propertyValue = object[property.name];

        if (typeof propertyValue == "boolean") {
            if (propertyValue) {
                propertyValue = 1;
            } else {
                propertyValue = 0;
            }
        }

        if (!property.subSubDiscriminatorName || (property.subSubDiscriminatorName === object[property.subSubDiscriminatorField])) {
            chartObject.push(object['timestamp'] - (timezoneOffset));
            chartObject.push(propertyValue);
        }
        return chartObject;
    }


    /**
     * To get a live view, we look at all the used message names and keep fetching new data for the selected properties.
     * By appending the data to the already existing data, we get a live-like view.
     */
    var updateLive = function () {
        var messageNames = ch.messageStructure.getMessageNamesWithSelectedProperties();
        var useCache = false;
        var replace = false;
        var fetchFunction = MessageDataRepository.getLiveMessageData;
        if (messageNames.length > 0) {
            ch.putMessagesOnChart(messageNames, fetchFunction, replace, useCache, ch.ignoreGaps);
        }
    };

    /**
     * Stops timeouts and starts a new timeout for the live update.
     */
    poller.pollData = function () {
        this.stopPoller();
        livePoller = $timeout(updateLive, ch.options.intervalTime * 1000);
    };

    /**
     * Cancels an existing poller.
     */
    poller.stopPoller = function () {
        if (util.isDefined(livePoller)) {
            $timeout.cancel(livePoller);
        }
    };

    ch.toggleTooltip = function () {
        "use strict";
        ch.chart.tooltip.hide();
        ch.chart.tooltipHidden = !ch.chart.tooltipHidden;
    };

    ch.toggleIgnoreGaps = function () {
        ch.options.ignoreGaps = !ch.options.ignoreGaps;
        UrlRoutingFactory.save("ignoreGaps", ch.options.ignoreGaps);
        addMessage();
    };

    ch.adjustStack = function () {
        "use strict";
        var saveName = $uibModal.open({
            template: analysisGraphStackingTpl,
            controller: "GraphStackingController",
            size: 'md',
            resolve: {
                series: function () {
                    var list = [];
                    ch.chart.series.forEach(function (serie) {
                        if (serie.name != "Navigator") {
                            list.push({
                                name: serie.name,
                                checked: serie.type == 'area'
                            });
                        }
                    });
                    return list;
                }
            }
        });

        saveName.result.then(function (data) {
            if (data.length > 0) {
                ch.stack = true;
                GraphStackingStorage.save(name, data);
            } else {
                ch.stack = false;
                GraphStackingStorage.clear(name);
            }

            UrlRoutingFactory.save("stacking", ch.stack);


            ch.applyStackingList(data);

        }, function () {

        });
    };

    ch.applyStackingList = function (data) {
        "use strict";
        data.forEach(function (seriesObject) {
            var serie = arrayUtil.getFirstInList(ch.chart.series, 'name', seriesObject.name);
            if (!util.isDefined(serie)) {
                console.warn("Unable to add serie. Selected property for discriminator/subdiscriminator is not available.");

            }
            var size = serie.size;
            if (seriesObject.checked) {
                serie.update({type: 'area', stacking: 'normal'}, false);
            } else {
                serie.update({type: 'line', stacking: null}, false);
            }
            serie.size = size;
        });
        ch.chart.redraw();
        
    };


    ch.toggleStack = function () {
        "use strict";
        ch.stack = !ch.stack;
        //UrlRoutingFactory.save("stacking", ch.stack);
        var list = ch.chart.series
            .filter(serie => serie.name != "Navigator")
            .map(serie => {
                return({
                    name: serie.name,
                    checked: ch.stack
                });
             });
        GraphStackingStorage.save(name, list);
        ch.applyStackingList(list);
    };

    ch.toggleStepLine = function () {
        "use strict";
        ch.step = !ch.step;
        ch.pointMarkersOnly = false;
        updateChartLine();
        
    };

    ch.toggleDotLine = function () {
        ch.pointMarkersOnly = !ch.pointMarkersOnly;
        updateChartLine();
    };



    var updateChartLine = () => {
        var promises = ch.chart.series.map(function (serie) {
            return  serie.update({
                step: ch.step,
                lineWidth: ch.pointMarkersOnly ? 0 : 1,
                marker: {
                    enabled: ch.pointMarkersOnly ? 1 : 0,
                    radius: ch.pointMarkerRadius ? ch.pointMarkerRadius : 2
                }
            }, false);
        });
        Promise.all(promises).then(() => {
            setTimeout(() => ch.chart.redraw(), 0);
        });
    }

    ch.applyFullStacking = function () {
        "use strict";
        if (ch.stack) {
            ch.chart.series.forEach(function (serie) {
                var size = serie.size;
                serie.update({type: 'area', stacking: 'normal'}, false);
                serie.size = size;
            });
        } else {
            ch.chart.series.forEach(function (serie) {
                var size = serie.size;
                serie.update({type: 'line', stacking: null}, false);
                serie.size = size;
            });
        }
        ch.chart.redraw();
    };

    /**
     * When this controller is destroyed, we have to make sure that the poller is stopped.
     * We need to unbind all binded events.
     */
    $scope.$on('$destroy', function () {
        poller.stopPoller();
    });

    init();
}];